import * as types from '../types/authTypes';
import {
  loginReader,
  registerReader,
  getReaderMe,
  persistReaderToken,
  getStoredReaderToken,
  verifyReaderEmail,
} from '../../services/authService';
import { syncLocalBookmarksToServer } from '../../utils/bookmarkSync';

async function afterAuthSuccess(dispatch, data, successType) {
  persistReaderToken(data.token);
  dispatch({
    type: successType,
    payload: { token: data.token, user: data.user },
  });
  try {
    await syncLocalBookmarksToServer();
  } catch {
    /* non-blocking */
  }
  return data;
}

export const loginUser = ({ email, password }) => async (dispatch) => {
  dispatch({ type: types.LOGIN_REQUEST });
  try {
    const data = await loginReader({ email, password });
    return await afterAuthSuccess(dispatch, data, types.LOGIN_SUCCESS);
  } catch (err) {
    const message = err?.response?.data?.message || 'Login failed';
    dispatch({ type: types.LOGIN_FAILURE, payload: message });
    throw err;
  }
};

export const registerUser = ({ displayName, email, password }) => async (dispatch) => {
  dispatch({ type: types.REGISTER_REQUEST });
  try {
    const data = await registerReader({ displayName, email, password });
    return await afterAuthSuccess(dispatch, data, types.REGISTER_SUCCESS);
  } catch (err) {
    const message = err?.response?.data?.message || 'Registration failed';
    dispatch({ type: types.REGISTER_FAILURE, payload: message });
    throw err;
  }
};

export const restoreSession = () => async (dispatch) => {
  const token = getStoredReaderToken();
  if (!token) return null;

  dispatch({ type: types.GET_USER_REQUEST });
  try {
    const data = await getReaderMe(token);
    dispatch({ type: types.GET_USER_SUCCESS, payload: data.user });
    return data.user;
  } catch {
    persistReaderToken(null);
    dispatch({ type: types.GET_USER_FAILURE, payload: 'Session expired' });
    return null;
  }
};

export const refreshReaderProfile = () => async (dispatch) => {
  try {
    const data = await getReaderMe();
    dispatch({ type: types.GET_USER_SUCCESS, payload: data.user });
    return data.user;
  } catch (err) {
    dispatch({ type: types.GET_USER_FAILURE, payload: 'Session expired' });
    throw err;
  }
};

export const verifyEmail = (token) => async (dispatch) => {
  const data = await verifyReaderEmail(token);
  if (data.user) {
    dispatch({ type: types.GET_USER_SUCCESS, payload: data.user });
  } else {
    await dispatch(refreshReaderProfile());
  }
  return data;
};

export const logoutUser = () => (dispatch) => {
  persistReaderToken(null);
  dispatch({ type: types.LOGOUT });
};
